import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'lucide-react';

export const PeriodSelector = ({ period, setPeriod }) => {
  const { t } = useTranslation('dashboard');
  const [isTimeDropdownOpen, setIsTimeDropdownOpen] = useState(false);

  const handleToggleDropdown = () => {
    setIsTimeDropdownOpen((prevState) => {
      const newState = !prevState;

      if (newState) {
        setTimeout(() => {
          const handleClickOutside = (event) => {
            if (!event.target.closest('.relative')) {
              setIsTimeDropdownOpen(false);
              document.removeEventListener('click', handleClickOutside);
            }
          };
          document.addEventListener('click', handleClickOutside);
        }, 0);
      }

      return newState;
    });
  };

  return (
    <div className="relative">
      <button
        type="button"
        className="w-[90px] sm:w-[114px] text-xs sm:text-sm text-gray-700 font-medium flex border border-gray-200 rounded-md py-1 px-2 sm:px-[10px] bg-white items-center justify-between"
        onClick={handleToggleDropdown}
      >
        {period === 'week' ? t('leaderboard.thisWeek') : t('leaderboard.thisMonth')}
        {isTimeDropdownOpen ? (
          <ChevronUp className="h-3 w-3 sm:h-4 sm:w-4" />
        ) : (
          <ChevronDown className="h-3 w-3 sm:h-4 sm:w-4" />
        )}
      </button>
      {isTimeDropdownOpen && (
        <div className="absolute right-0 mt-2 w-28 sm:w-32 bg-white rounded-lg border border-gray-200 z-10">
          <button
            key="week"
            type="button"
            className="w-full text-center px-2 sm:px-[12px] py-2 sm:py-[10px] text-xs sm:text-sm bg-white border-none rounded-t-lg text-gray-700 hover:bg-gray-50"
            onClick={() => {
              setPeriod('week');
              setIsTimeDropdownOpen(false);
            }}
          >
            {t('leaderboard.thisWeek')}
          </button>
          <button
            key="month"
            type="button"
            className="w-full text-center px-2 sm:px-[12px] py-2 sm:py-[10px] text-xs sm:text-sm bg-white border-none rounded-b-lg text-gray-700 hover:bg-gray-50"
            onClick={() => {
              setPeriod('month');
              setIsTimeDropdownOpen(false);
            }}
          >
            {t('leaderboard.thisMonth')}
          </button>
        </div>
      )}
    </div>
  );
};
